export const holderCalcTypeConst = {
  costA: "cost_a",
  costB: "cost_b"
};

export class Scenario {
  id?: number;
  active = false;
  calcType = "hacoplay";
  displayMethodTypeName = "箱プレ";
  scenarioName = "";
  woodenModalCalcSkip = false;
  packingCostCalcSkip = false;
  itemPrinterId = -1;
  itemPaperSizeId = -1;
  groupCoaters: number[] = [];
  groupGlues: number[] = [];
  groupDieCuts: number[] = [];
  groupCustoms: number[] = [];
  holderCalcType = holderCalcTypeConst.costA;
  scenarioMargins: ScenarioMargin[] = [];
}

export class ScenarioMargin {
  id?: number;
  deliveryDateTypeId = 0;
  fixedCost = 0;
  rate = 0;
  scenarioId = 0;
}
